import {dataTestId, dateRangeFormatter} from '@hconnect/uikit'
import {HPTextField, HPTextFieldProps} from '@hconnect/uikit/src/lib2'
import {MenuItem} from '@mui/material'
import moment from 'moment-timezone'
import {useTranslation} from 'react-i18next'

import {type MomentRange} from '../utils'

const getValue = ([start, end]: MomentRange) => `${start.toISOString()}_${end.toISOString()}`

const getMomentRange = (value: string): MomentRange => {
  const [start, end] = value.split('_')
  return [moment.utc(start), moment.utc(end)]
}

export interface TimeFrameSelectOption {
  label?: string
  timeFrame: MomentRange
}

type TimeFrameSelectProps = Pick<HPTextFieldProps, 'backgroundMode' | 'label'> & {
  timeFrame: MomentRange
  options: TimeFrameSelectOption[]
  onChange: (timeFrame: MomentRange) => void
}

export const TimeFrameSelect: React.FC<TimeFrameSelectProps> = ({
  timeFrame,
  options,
  onChange,
  ...otherProps
}) => {
  const {
    i18n: {language}
  } = useTranslation()

  return (
    <HPTextField
      sx={{width: ({spacing}) => spacing(28)}}
      fullWidth
      select
      value={getValue(timeFrame)}
      onChange={({target: {value}}) => onChange(getMomentRange(value))}
      {...otherProps}
      {...dataTestId('timeframe_select')}
    >
      {options.map(({label, timeFrame}, index) => (
        <MenuItem key={index} value={getValue(timeFrame)}>
          {label ?? dateRangeFormatter(timeFrame[0], timeFrame[1], language)}
        </MenuItem>
      ))}
    </HPTextField>
  )
}
